module.exports = __webpack_public_path__ + "img/tree11.44a4630f.png";